import "./styles.css";

function isFieldError(array, val) {
	return array.includes(val);
}

const Select = ({ label, req, name, data, value, update, errors }) => {
	return (
		<div className="select">
			<label htmlFor={name} className={!label ? "hidden" : ""}>
				{`${label}`} {req ? <span className="error">*</span> : null}
			</label>
			<select
				name={name}
				id={name}
				defaultValue={value || ""}
				onChange={(e) => update(name, e.target.value)}
				autoComplete="off"
				className={isFieldError(errors, name) ? "error-border" : ""}
			>
				{data.map((item, index) => {
					return (
						<option key={index} value={item.value}>
							{item.name}
						</option>
					);
				})}
			</select>
		</div>
	);
};

export default Select;
